<template>
  <v-layout align-start>
    <!-- Snackbar -->
    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>
    <!-- CONFIRM DIALOG -->
    <v-dialog v-model="confirmDialog" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">
          Enviar Guardia Futuro ({{ tipoGuardia.toLocaleLowerCase() }})
        </v-card-title>
        <v-card-text class="body-2">
          ¿Está seguro de que desea enviar la guardia de FUTURO ASISTENCIA de la
          siguiente fecha
          {{ complementoTextoGuardia }}?
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-btn color="primary" outlined @click="confirmDialog = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirmAction"> Enviar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- SENT DIALOG -->
    <v-dialog v-model="sentDialog" persistent max-width="400">
      <v-form ref="formReenvio">
        <v-card>
          <v-card-title class="headline">
            Reenvío de Guardia Futuro
          </v-card-title>
          <v-card-text class="body-2">
            <v-row class="px-3 mb-3">
              Sí desea reenviar una guardia de FUTURO ASISTENCIA. Por favor,
              selecciona el día.
            </v-row>
            <v-row class="px-3">
              <v-text-field
                v-model="fechaReenvio"
                type="date"
                hide-details
                label="Fecha"
                :rules="requiredRule"
                :max="new Date().toISOString().substr(0, 10)"
                clearable
              ></v-text-field>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-btn color="primary" outlined @click="closeReenvio">
              Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="reenvioGuardia"
              :disabled="!fechaReenvio"
            >
              Reenviar
            </v-btn>
            <v-btn
              color="success"
              @click="descargarExcelFuturo"
              :disabled="!fechaReenvio"
            >
              Descargar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-flex>
      <v-data-table
        :headers="headers"
        :items="cabinas"
        class="elevation-1"
        no-data-text="No hay datos"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Guardia v2</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-row no-gutters>
              <v-col cols="2" align-self="center">
                <v-autocomplete
                  v-model="idPerfil"
                  :items="itemsPerfiles"
                  item-text="nombre"
                  item-value="idPerfilGuardia"
                  label="Seleccionar perfil"
                  hide-details
                  clearable
                  return-object
                  @change="verNombreCartera"
                >
                </v-autocomplete>
              </v-col>
              <v-col
                cols="auto"
                align-self="center"
                class="ml-3"
                v-if="!idPerfil"
              >
                <v-btn color="primary" @click="dialogNuevoPerfil = true"
                  >Nuevo perfil</v-btn
                >
              </v-col>

              <v-col
                cols="auto"
                class="ml-3"
                :class="{ 'pt-5': mostrarGuardiaFuturo }"
                v-if="idPerfil"
              >
                <v-btn
                  v-if="idPerfil.idPerfilGuardia != 0"
                  color="primary"
                  @click="detallesPerfil"
                  >Actualizar perfil</v-btn
                >
              </v-col>
              <v-col cols="auto" align-self="center" v-if="idPerfil">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" v-bind="attrs" v-on="on" class="ml-3"
                      >Filtrar</v-btn
                    >
                  </template>
                  <v-card class="pa-2">
                    Desde:
                    <v-text-field
                      hide-details
                      dense
                      type="date"
                      v-model="fechaInicio"
                    ></v-text-field>
                    Hasta:
                    <v-text-field
                      hide-details
                      dense
                      type="date"
                      v-model="fechaFin"
                    ></v-text-field>
                    <v-card-actions class="pb-0 pr-0">
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="listarCabina"
                        >Listar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-col>
              <v-col cols="4" v-if="mostrarGuardiaFuturo">
                <v-row class="pa-0 ma-0">
                  <v-col>
                    <v-btn
                      class="ma-2"
                      :loading="loaderFuturo"
                      :disabled="loaderFuturo"
                      color="info"
                      @click="confirmDialog = true"
                    >
                      <v-icon class="fa fa-paper-plane mr-2"></v-icon>
                      Enviar Guardia Futuro
                      <template v-slot:loader>
                        <span class="custom-loader">
                          <v-icon light>fa-sync-alt</v-icon>
                        </span>
                      </template>
                    </v-btn>
                  </v-col>
                  <v-col
                    class="ma-0 pa-0 pt-5"
                    v-if="
                      $store.state.usuario.rol == 'Administrador' ||
                      $store.state.usuario.rol == 'Personal Administrativo' ||
                      $store.state.usuario.rol == 'Team Leader Cabina'
                    "
                  >
                    <v-btn
                      :loading="loaderFuturo"
                      :disabled="loaderFuturo"
                      color="info"
                      @click="openReenvio"
                    >
                      <v-icon class="fa fa-paper-plane"></v-icon>
                      Reenvio
                      <template v-slot:loader>
                        <span class="custom-loader">
                          <v-icon light>fa-sync-alt</v-icon>
                        </span>
                      </template>
                    </v-btn>
                  </v-col>
                  <!-- <v-col class="ma-0 pa-0 pt-6">
                    <v-autocomplete
                      v-model="tipoGuardia"
                      :items="['DIARIA', 'MENSUAL']"
                      label="Tipo Guardia"
                      hide-details
                    >
                    </v-autocomplete>
                  </v-col> -->
                </v-row>
              </v-col>
              <v-spacer></v-spacer>
              <v-col>
                <v-row
                  class="pa-0 ma-0"
                  :class="{ 'pt-5': mostrarGuardiaFuturo }"
                >
                  <v-btn
                    color="success"
                    @click="seleccionarCampos"
                    v-if="cabinas.length > 0 && idPerfil.nombre != undefined"
                    >Descargar</v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
      </v-data-table>

      <v-dialog v-model="dialogNuevoPerfil" max-width="800" persistent>
        <v-card>
          <v-card-title
            >Perfil
            <v-spacer></v-spacer>
            <v-btn class="mr-3" outlined @click="cerrarDialog()">Cerrar</v-btn>
            <v-btn
              v-if="bandera != 0"
              color="primary"
              @click="actualizarPerfil()"
              >Actualizar</v-btn
            >
            <v-btn v-if="bandera == 0" color="primary" @click="guardarPerfil()"
              >Guardar</v-btn
            >
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6" class="mx-auto">
                <v-text-field
                  v-model="nombrePerfil"
                  label="Nombre del perfil"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="mx-auto">
                <v-autocomplete
                  v-model="nombreCartera"
                  :items="itemsCartera"
                  item-value="nombre"
                  item-text="nombre"
                  label="Cartera"
                  hint="Si deja este campo vacío descargará la información de todas las carteras"
                  persistent-hint
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="auto"
                v-for="(selection, i) in selections"
                :key="selection.text"
              >
                <v-chip
                  close
                  @click:close="selectedRemovido(i, selection)"
                  :value="selection.idCampoCabina"
                >
                  {{ selection.nombrePersonalizado }}
                </v-chip>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  ref="search"
                  v-model="search"
                  hide-details
                  label="Buscar"
                  single-line
                >
                </v-text-field>
              </v-col>
              <v-col>
                <v-list>
                  <template v-for="item in filtro">
                    <v-list-item :key="item.text" @click="selected.push(item)">
                      <v-list-item-avatar>
                        <v-icon>fas fa-circle</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-title>{{
                        item.nombrePersonalizado
                      }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";
var moment = require("moment");

export default {
  data() {
    return {
      talleresSISA: [],
      soloDescargaFuturo: false,
      search: "",
      responseJSON: [],
      cabinas: [],
      confirmDialog: false,
      snack: false,
      snackColor: "primary",
      snackText: "text",
      snackTime: 4500,
      tipoGuardia: "DIARIA",
      itemsPerfiles: [],
      fechaReenvio: new Date().toISOString().substr(0, 10),
      sentDialog: false,
      reenvio: false,
      guardiaFuturo: [],
      tempAsistencias: [],
      departamentosFuturo: [],
      municipiosFuturo: [],
      itemsCamposCabina: [],
      loaderFuturo: false,
      itemsCartera: [],
      headers: [
        {
          text: "Numero Asistencia",
          value: "numeroAsistencia",
          sortable: true,
        },
        { text: "Cartera", value: "cartera", sortable: true },
        { text: "Fecha Actual", value: "fechaHoraActual", sortable: true },
        { text: "Placa", value: "placa", sortable: true },
        { text: "Poliza", value: "polizaBase", sortable: true },
        { text: "Marca", value: "marcaBase", sortable: true },
        { text: "Modelo", value: "modeloBase", sortable: true },
        { text: "Año", value: "añoBase", sortable: true },
        { text: "Titular Poliza", value: "titularPolizaBase", sortable: true },
      ],
      nombreCartera: "",
      fechaInicio: "",
      fechaFin: "",
      overlay: false,
      requiredRule: [(v) => !!v || "Campo Requerido."],
      idPerfil: "",
      camposCabina: [],
      dialogNuevoPerfil: false,
      nombrePerfil: "",
      selected: [],
      bandera: 0,
      final: [],
      removidos: [],
      nombresSeleccionados: [],
      menu: false,
    };
  },
  computed: {
    complementoTextoGuardia() {
      const rangoFechas = this.obtenerRangoMesAnterior();
      let complemento = "";
      if (this.tipoGuardia == "DIARIA") {
        complemento = ` del día ${this.getFechaAyer()}`;
      } else {
        complemento = ` mensual del periodo de ${rangoFechas.primerDia} a ${rangoFechas.ultimoDia}`;
      }

      return complemento;
    },
    mostrarGuardiaFuturo() {
      return (
        this.$store.state.usuario.rol == "Coordinador Cabina" ||
        this.$store.state.usuario.rol == "Administrador" ||
        this.$store.state.usuario.rol == "Personal Administrativo" ||
        this.$store.state.usuario.rol == "Team Leader Cabina"
      );
    },
    filtro() {
      const search = this.search.toLowerCase();

      if (!search) return this.itemsCamposCabina;

      return this.itemsCamposCabina.filter((item) => {
        const text = item.nombrePersonalizado.toLowerCase();

        return text.indexOf(search) > -1;
      });
    },
    selections() {
      const selections = [];

      for (const selection of this.selected) {
        selections.push(selection);
      }

      return selections;
    },
  },
  watch: {
    selected() {
      this.search = "";
    },
  },
  created() {
    this.listarComboBox();
  },
  methods: {
    descargarExcelFuturo() {
      this.soloDescargaFuturo = true;
      this.getAsistenciasGuardiaFuturo();
    },
    getFechaAyer() {
      let today = new Date();
      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);

      let fechaGuardado =
        yesterday.getFullYear() +
        "-" +
        (yesterday.getMonth() + 1) +
        "-" +
        yesterday.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();

      return this.formatoFecha(fechaGuardado);
    },
    confirmAction() {
      if (this.tipoGuardia == "DIARIA") {
        this.getAsistenciasGuardiaFuturo();
      }
      // else {
      //   this.getAsistenciasGuardiaFuturoMensual();
      // }
    },
    reenvioGuardia() {
      if (this.$refs.formReenvio.validate()) {
        this.getAsistenciasGuardiaFuturo();
      } else {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Debe Seleccionar una Fecha";
      }
    },
    openReenvio() {
      this.sentDialog = true;
      this.reenvio = true;

      this.fechaReenvio = new Date().toISOString().substr(0, 10);
    },
    closeReenvio() {
      this.sentDialog = false;
      this.reenvio = false;

      if (this.$refs.formReenvio) {
        this.$refs.formReenvio.resetValidation();
      }
    },
    obtenerRangoMesAnterior() {
      const fechaActual = new Date();
      const primerDiaMesActual = new Date(
        fechaActual.getFullYear(),
        fechaActual.getMonth(),
        1
      );
      const ultimoDiaMesAnterior = new Date(primerDiaMesActual);
      ultimoDiaMesAnterior.setDate(0); // Esto establece el último día del mes anterior
      const primerDiaMesAnterior = new Date(
        ultimoDiaMesAnterior.getFullYear(),
        ultimoDiaMesAnterior.getMonth(),
        1
      );

      return {
        primerDia: this.formatoFecha(primerDiaMesAnterior),
        ultimoDia: this.formatoFecha(ultimoDiaMesAnterior),
      };
    },
    normalizarMunicipio(municipio) {
      const clave = municipio
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
      return this.municipiosFuturo.get(clave) || municipio;
    },
    normalizarDepartamento(depto) {
      const clave = depto
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
      return this.departamentosFuturo.get(clave) || depto;
    },
    listarComboBox() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "https://wsfuturomovil2.segurosfuturo.net:7731/serviceAsistencia/GetGuardiaMunicipios"
        )
        .then((res) => {
          //this.municipiosFuturo = res.data
          const diccionario = new Map();
          res.data.forEach((municipio) => {
            const clave = municipio.xdescripcion
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase();
            diccionario.set(clave, municipio.xdescripcion);
          });

          this.municipiosFuturo = diccionario;
        })
        .catch((err) => console.error(err));

      axios
        .get(
          "https://wsfuturomovil2.segurosfuturo.net:7731/serviceAsistencia/GetGuardiaDepartamentos"
        )
        .then((res) => {
          // this.departamentosFuturo = res.data
          const diccionario = new Map();
          res.data.forEach((departamento) => {
            const clave = departamento.xdescripcion
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase();
            diccionario.set(clave, departamento.xdescripcion);
          });

          this.departamentosFuturo = diccionario;
        })
        .catch((err) => console.error(err));

      axios
        .get("api/TallerSisa", configuracion)
        .then((res) => {
          this.talleresSISA = res.data;
        })
        .catch((err) => {
          console.log(err);
        });

      this.listarCarteras();
      this.listarCamposCabina();
      this.listarPerfiles();
    },
    getAsistenciasGuardiaFuturo() {
      this.loaderFuturo = true;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      let query = "";

      if (this.reenvio) {
        query = `?inicio=${this.fechaReenvio}&fin=${this.fechaReenvio}&reenvio=${this.reenvio}`;
      } else {
        query = `?inicio=${this.getFechaAyer()}&fin=${this.getFechaAyer()}&reenvio=false`;
      }

      if (this.soloDescargaFuturo) {
        query = `?inicio=${this.fechaReenvio}&fin=${this.fechaReenvio}&reenvio=${this.reenvio}&soloDescarga=true`;
      }

      axios
        .get(`api/Cabinas/GuardiaFuturo${query}`, configuracion)
        .then((res) => {
          this.guardiaFuturo = res.data;
          if (this.guardiaFuturo?.modify) {
            this.tempAsistencias = this.guardiaFuturo.asistencias;
          } else {
            this.tempAsistencias = this.guardiaFuturo.asistencias.map(
              (asistencia) => {
                return {
                  ...asistencia,
                  municipio: this.normalizarMunicipio(asistencia.municipio),
                  departamento: this.normalizarDepartamento(
                    asistencia.departamento
                  ),
                };
              }
            );
          }

          this.exportExcel(this.tempAsistencias);

          if (this.soloDescargaFuturo == false) {
            this.enviarGuardiaFuturo();
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
            this.snack = true;
            this.snackColor = "error";
            if (err.response.data) {
              this.snackText = err.response.data;
            } else {
              this.snackText = "No se pudieron consultar las asistencias";
            }
          }
        })
        .finally(() => {
          this.loaderFuturo = false;
          this.confirmDialog = false;
          this.soloDescargaFuturo = false;
        });
    },
    getAsistenciasGuardiaFuturoMensual() {
      return;
      this.loaderFuturo = true;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      const rangoFechas = this.obtenerRangoMesAnterior();

      axios
        .get(
          `api/Cabinas/GuardiaFuturo?inicio=${rangoFechas.primerDia}&fin=${rangoFechas.ultimoDia}`,
          configuracion
        )
        .then((res) => {
          this.guardiaFuturo = res.data;
          this.tempAsistencias = this.guardiaFuturo.asistencias.map(
            (asistencia) => {
              return {
                ...asistencia,
                municipio: this.normalizarMunicipio(asistencia.municipio),
                departamento: this.normalizarDepartamento(
                  asistencia.departamento
                ),
              };
            }
          );

          this.exportExcel(this.tempAsistencias);
          // this.enviarGuardiaFuturo();
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
            this.snack = true;
            this.snackColor = "error";
            if (err.response.data) {
              this.snackText = err.response.data;
            } else {
              this.snackText = "No se pudieron consultar las asistencias";
            }
          }
          this.loaderFuturo = false;
          this.confirmDialog = false;
        });
    },
    guardarResponseJSON(historialGuardiaId) {
      let header = {
        Authorization: "Bearer " + this.$store.state.token,
        "Content-Type": "application/json",
      };
      let configuracion = { headers: header };
      const responseString = JSON.stringify(this.responseJSON);

      axios
        .put(
          `api/HistorialGuardia/${historialGuardiaId}/ResponseJSON`,
          responseString,
          configuracion
        )
        .catch((err) => console.error(err));
    },
    enviarGuardiaFuturo() {
      if (this.guardiaFuturo == null || this.tempAsistencias == null) return;

      let mesGuardiaMensual = "N";

      if (this.tipoGuardia == "MENSUAL") {
        const mesAnterior = new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 1,
          new Date().getDay()
        );

        mesGuardiaMensual = mesAnterior
          .toLocaleString("es-ES", { month: "long" })
          .toLocaleUpperCase();
      }

      if (this.guardiaFuturo?.modify) {
        axios
          .post(
            "https://wsfuturomovil2.segurosfuturo.net:7731/serviceAsistencia/ModificaGuardia",
            {
              nlote: this.guardiaFuturo.nlote,
              tipo_guardia: this.tipoGuardia,
              mes_guardia_mensual: mesGuardiaMensual,
              camposGuardiaRegional: this.tempAsistencias,
            }
          )
          .then((res) => {
            const errors = res.data.filter((res) => res.respuesta != "00");
            this.responseJSON = res.data;
            let asistenciaErrores = "";

            if (errors.length != 0) {
              asistenciaErrores = errors
                .map((err) => err.nasistencia)
                .join(",");
            }
            //AGREGAR A HISTORIAL
            this.agregarHistorialGuardia(asistenciaErrores);
          })
          .catch((err) => {
            console.error(err);
            this.snack = true;
            this.snackText = "¡No se pudo enviar la guardia generada!";
            this.snackColor = "error";
          })
          .finally(() => {
            this.loaderFuturo = false;
            this.confirmDialog = false;
            this.sentDialog = false;
          });
      } else {
        axios
          .post(
            "https://wsfuturomovil2.segurosfuturo.net:7731/serviceAsistencia/CargaGuardia",
            {
              nlote: this.guardiaFuturo.nlote,
              tipo_guardia: this.tipoGuardia,
              mes_guardia_mensual: mesGuardiaMensual,
              camposGuardiaRegional: this.tempAsistencias,
            }
          )
          .then((res) => {
            const errors = res.data.filter((res) => res.respuesta != "00");
            this.responseJSON = res.data;
            let asistenciaErrores = "";

            if (errors.length != 0) {
              asistenciaErrores = errors
                .map((err) => err.nasistencia)
                .join(",");
            }
            //AGREGAR A HISTORIAL
            this.agregarHistorialGuardia(asistenciaErrores);
          })
          .catch((err) => {
            console.error(err);
            this.snack = true;
            this.snackText = "¡No se pudo enviar la guardia generada!";
            this.snackColor = "error";
          })
          .finally(() => {
            this.loaderFuturo = false;
            this.confirmDialog = false;
            this.sentDialog = false;
          });
      }
    },
    agregarHistorialGuardia(asistenciaErrores) {
      //AGREGAR A HISTORIAL
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/HistorialGuardia",
          {
            usuario: this.$store.state.usuario.nombre,
            usuarioId: this.$store.state.usuario.idUsuario,
            nlote: this.guardiaFuturo.nlote,
            tipoGuardia: this.tipoGuardia,
            asistenciaErrores: asistenciaErrores,
          },
          configuracion
        )
        .then((res) => {
          this.guardarResponseJSON(res.data);

          this.snack = true;
          this.snackText = "Guardia fue enviada y guardada correctamente!";
          this.snackColor = "primary";
        })
        .catch((err) => {
          console.err(err);
          this.snack = true;
          this.snackText = "No se pudo guardar el historial!";
          this.snackColor = "error";
        });
    },
    listarCarteras() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/Carteras/Activas", configuracion)
        .then((res) => {
          this.itemsCartera = res.data.filter(
            (c) => c.nombre != "FUTURO ASISTENCIA"
          );
        })
        .catch((err) => console.error(err.response));
    },
    listarCabina() {
      if (this.fechaInicio && this.fechaFin) {
        var url = "";
        if (!this.nombreCartera) {
          if (this.idPerfil.idPerfilGuardia == 0) {
            url = `api/CabinaxPerfiles/GuardiaCostos?inicio=${this.fechaInicio}&fin=${this.fechaFin}`;
          } else {
            url =
              "api/Cabinas/ListarxGuardia/" +
              this.fechaInicio +
              "/" +
              this.fechaFin;
          }
        } else {
          url =
            "api/Cabinas/ListarxCartera/" +
            this.fechaInicio +
            "/" +
            this.fechaFin +
            "/" +
            this.nombreCartera;
        }
        let header = { Authorization: "Bearer " + this.$store.state.token };
        let configuracion = { headers: header };
        axios
          .get(url, configuracion)
          .then((response) => {
            this.cabinas = response.data;
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    listarCamposCabina() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/CamposCabina/Listar", configuracion)
        .then((response) => {
          this.itemsCamposCabina = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    agregarAuditorCosto() {
      if (this.$store.state.usuario.idRol == 19) {
        this.itemsPerfiles.push({
          idPerfilGuardia: 0,
          nombre: "AUDITOR COSTOS",
          cartera: "",
        });
      }
    },
    listarPerfiles() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Perfiles/Listar", configuracion)
        .then((response) => {
          this.itemsPerfiles = response.data;

          this.agregarAuditorCosto();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    verNombreCartera() {
      if (this.idPerfil) {
        this.nombreCartera = this.idPerfil.cartera;
      } else {
        this.nombreCartera = "";
      }
    },
    guardarPerfil() {
      //primero se guardara el perfil y automaticamente se guardaran los campos
      var array = [];
      this.selections.forEach((element) => {
        array.push({
          idCampoCabina: element.idCampoCabina,
          idUsuario: this.$store.state.usuario.idUsuario,
        });
      });

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .post(
          "api/Perfiles/Crear",
          {
            nombre: this.nombrePerfil,
            cartera: this.nombreCartera,
            cabinaxPerfil: array,
          },
          configuracion
        )
        .then(() => {
          this.dialogNuevoPerfil = false;
          this.limpiar();
          this.listarPerfiles();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    detallesPerfil() {
      this.bandera = 1;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/CabinaxPerfiles/Listar/" + this.idPerfil.idPerfilGuardia,
          configuracion
        )
        .then((response) => {
          this.nombrePerfil = this.idPerfil.nombre;
          this.nombreCartera = response.data[0].nombreCartera;
          response.data.forEach((element) => {
            this.selections.push(element);
            this.selected.push(element);
          });
          this.dialogNuevoPerfil = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    actualizarPerfil() {
      //para actualizar primero se actualizar el perfil, luego se eliminaran los camposxPerfiles y volver a crearlos
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "api/Perfiles/Actualizar",
          {
            idPerfilGuardia: this.idPerfil.idPerfilGuardia,
            nombre: this.nombrePerfil,
            cartera: this.nombreCartera,
          },
          configuracion
        )
        .then(() => {
          this.eliminarCabinaxPerfil();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    eliminarCabinaxPerfil() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      this.selected.forEach(async (element) => {
        if (!element.idCabinaxPefil) {
          await axios
            .post(
              "api/CabinaxPerfiles/Crear",
              {
                idCampoCabina: element.idCampoCabina,
                idPerfilGuardia: this.idPerfil.idPerfilGuardia,
                idUsuario: this.$store.state.usuario.idUsuario,
              },
              configuracion
            )
            .catch((error) => {
              console.log(error);
            });
        }
      });

      this.removidos.forEach(async (element) => {
        if (element.idCabinaxPefil) {
          await axios
            .delete(
              "api/CabinaxPerfiles/Eliminar/" + element.idCabinaxPefil,
              configuracion
            )
            .catch((error) => {
              console.log(error);
            });
        }
      });
      this.cerrarDialog();
    },
    selectedRemovido(i, item) {
      this.selected.splice(i, 1);
      this.removidos.push(item);
    },
    cerrarDialog() {
      this.dialogNuevoPerfil = false;
      this.bandera = 0;
      this.limpiar();
    },
    limpiar() {
      this.camposCabina = [];
      this.nombrePerfil = "";
      this.nombreCartera = "";
      this.selected = [];
      this.removidos = [];
      this.reenvio = false;
    },
    async seleccionarCampos() {
      if (this.idPerfil.idPerfilGuardia == 0) {
        this.excel();
      } else {
        this.nombresSeleccionados = [];
        this.final = [];

        let header = { Authorization: "Bearer " + this.$store.state.token };
        let configuracion = { headers: header };
        await axios
          .get(
            "api/CabinaxPerfiles/Listar/" + this.idPerfil.idPerfilGuardia,
            configuracion
          )
          .then((response) => {
            this.nombresSeleccionados = response.data;
          })
          .catch((error) => {
            console.log(error);
          });

        for (var i = 0; i < this.nombresSeleccionados.length; i++) {
          this.extractValue(
            this.cabinas,
            this.nombresSeleccionados[i].nombreBase,
            this.nombresSeleccionados[i].nombrePersonalizado,
            this.nombresSeleccionados[i].tipoDato
          );
        }

        this.excel();
      }
    },
    extractValue(arr, prop, propP, propTipoDato) {
      arr.map((item, index) => {
        if (this.final[index] != undefined) {
          this.formatoCampos(propTipoDato, index, propP, prop, item);
        } else {
          this.formatoCamposUndefined(propTipoDato, propP, prop, item);
        }
      });
    },
    formatoCampos(propTipoDato, index, propP, prop, item) {
      if (propTipoDato == "string") {
        this.final[index][propP] = item[prop];
      } else if (propTipoDato == "dateTime") {
        if (item[prop] != null && item[prop] != "") {
          this.final[index]["FECHA " + propP.split(" ").splice(-1)[0]] =
            this.formatoFecha(item[prop]);
          this.final[index]["HORA " + propP.split(" ").splice(-1)[0]] =
            this.formatoHora(item[prop]);
        } else {
          this.final[index]["FECHA " + propP.split(" ").splice(-1)[0]] = "";
          this.final[index]["HORA " + propP.split(" ").splice(-1)[0]] = "";
        }
      } else if (propTipoDato == "int") {
        this.final[index][propP] = item[prop];
      } else if (propTipoDato == "bool") {
        if (item[prop]) {
          this.final[index][propP] = "SI";
        } else {
          this.final[index][propP] = "NO";
        }
      }
    },
    formatoCamposUndefined(propTipoDato, propP, prop, item) {
      if (propTipoDato == "string") {
        this.final.push({
          [propP]: item[prop],
        });
      } else if (propTipoDato == "dateTime") {
        this.final.push({
          ["FECHA " + propP.split(" ").splice(-1)[0]]: this.formatoFecha(
            item[prop]
          ),
          ["HORA " + propP.split(" ").splice(-1)[0]]: this.formatoHora(
            item[prop]
          ),
        });
      } else if (propTipoDato == "int") {
        this.final.push({
          [propP]: item[prop],
        });
      } else if (propTipoDato == "bool") {
        if (item[prop]) {
          this.final.push({
            [prop]: "SI",
          });
        } else {
          this.final.push({
            [prop]: "NO",
          });
        }
      }
    },
    formatoFecha(fecha) {
      return moment(fecha).format("YYYY-MM-DD");
    },
    formatoHora(fecha) {
      return moment(fecha).format("HH:mm:ss");
    },
    exportExcel(asistencias) {
      let data = XLSX.utils.json_to_sheet(asistencias);
      const workbook = XLSX.utils.book_new();

      const filename = `Guardia Futuro ${
        this.reenvio ? this.fechaReenvio : this.getFechaAyer()
      }`;

      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    asignarNombresDeTalleres(data) {
      const mapaTalleres = new Map();
      this.talleresSISA.forEach((taller) => {
        mapaTalleres.set(taller.id, taller.nombre);
      });

      const conTaller = data.map((registro) => {
        if (registro.TALLER !== undefined && registro.TALLER !== null) {
          const nombreTaller = mapaTalleres.get(registro.TALLER);
          return {
            ...registro,
            TALLER: nombreTaller || "",
          };
        }

        return registro;
      });
      return conTaller;
    },
    excel() {
      let data;

      if (this.idPerfil.idPerfilGuardia == 0) {
        data = XLSX.utils.json_to_sheet(this.cabinas);
      } else {
        data = XLSX.utils.json_to_sheet(
          this.asignarNombresDeTalleres(this.final)
        );
      }
      const workbook = XLSX.utils.book_new();
      const filename = "Guardia " + this.idPerfil.nombre;
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
  },
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>